import { Controller, Control } from 'react-hook-form';
import { Checkbox } from '@schibsted-svp/react-ui';
import type { FormValues } from '../types';

type ShowAdsCheckboxProps = {
    control: Control<FormValues>;
};
export function ShowAdsCheckbox({ control }: ShowAdsCheckboxProps) {
    return (
        <Controller
            name="additional.settings.showAds"
            control={control}
            render={({ field: { value, ...rest } }) => (
                <Checkbox
                    {...rest}
                    checked={!value}
                    onChange={(event) => rest.onChange(!event.currentTarget.checked)}
                    label="Disable ads"
                />
            )}
        />
    );
}
